import Tab from "../../components/Tab";

export function Dashboards() {
  return <Tab />;
}
